import { render, staticRenderFns } from "./IconTick.vue?vue&type=template&id=5f019aa7&"
import script from "./IconTick.vue?vue&type=script&lang=js&"
export * from "./IconTick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports